export const getNights = (startDate, endDate) => {
    // hours * minutes * seconds * milliseconds
    const oneDay = 24 * 60 * 60 * 1000;

    const sdate = new Date(startDate);
    const edate = new Date(endDate);

    return Math.round(Math.abs((edate.getTime() - sdate.getTime()) / oneDay));
};

export const getTotal = (items) => {
    let total = 0;

    items.forEach((item) => {
        const quantity = getNights(item.duration.start_date, item.duration.end_date);
        total += item.cost * quantity;
    });

    return total;
};

export const calculateTax = (amount, taxRate) => amount * taxRate;

// formatTime formats time input (in seconds) and returns the minutes and seconds representation.
export const formatTime = (inputTime) => {
    let minutes = parseInt(inputTime / 60, 10);
    let seconds = parseInt(inputTime % 60, 10);

    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    return `${minutes}:${seconds}`;
};

/* eslint-disable quote-props */
export const mockUserEquipment = {
    'Tent': {
        NAME: 'My Tent',
        LENGTH: 0
    },
    'RV/Motorhome': {
        NAME: 'My RV',
        LENGTH: 24
    },
    'Trailer': {
        NAME: 'My Trailer',
        LENGTH: 12
    },
    'Pop up': {
        NAME: 'My Popup',
        LENGTH: 10
    },
    'Caravan/Camper Van': {
        NAME: 'My Camper',
        LENGTH: 20
    },
    'Pickup Camper': {
        NAME: 'My Pickup Camper',
        LENGTH: 20
    },
    'Fifth Wheel': {
        NAME: 'My Fifth Wheel',
        LENGTH: 12
    },
    'Large Tent Over 9X12`': {
        NAME: 'My Large Tent Over 9X12`',
        LENGTH: 0
    },
    'Small Tent': {
        NAME: 'My Small Tent',
        LENGTH: 0
    },
    'Boat': {
        NAME: 'My Boat',
        LENGTH: 10
    }
};
/* eslint-enable quote-props */
